module.exports = "<p>logout works!</p>\r\n"